module.exports = __webpack_public_path__ + "img/kitkitmaindp@4x.b33e6532.png";